import randomBase64Hash from '../utils/randomBase64Hash'
import { addListener } from './addListener'
import { createError } from './createError'
import { postMessage } from './postMessage'
import { removeListener } from './removeListener'

export function call(
  type: string,
  params: any = {},
  options: {
    callbackId?: string
    once?: boolean
  } = {
    once: true,
  },
): Promise<any> {
  options = {
    callbackId: randomBase64Hash(12),
    once: true,
    ...options,
  }

  return new Promise((resolve, reject): void => {
    const callbackHandler = (e: CustomEvent): void => {
      if (e && e.detail) {
        // callbackId exist, then match. if not, just exec
        const { callbackId } = e.detail
        const hasCorrespondingCallbackId = callbackId === options.callbackId
        const callbackIdIsNotSet = typeof e.detail.callbackId !== 'string'
        if (hasCorrespondingCallbackId || callbackIdIsNotSet) {
          if (options.once) {
            removeListener(type, callbackHandler)
          }
          if (e.detail.error) {
            reject(createError(e.detail.error))
          } else if (e.detail.data) {
            resolve(e.detail.data)
          } else {
            reject(e.detail)
          }
        }
      }
    }

    addListener(type, callbackHandler)
    postMessage(type, params, options.callbackId)
  })
}
